class RelatedProductsSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (typeof Swiper !== 'undefined') {
      this.initializeSlider();
      this.updateHighestPrice();
    }
  }

  initializeSlider() {
    const swiperElement = this.querySelector('[data-swiper-related-products]');
    const paginationElement = this.querySelector('[data-swiper-related-products-pagination]');
    const nextButtonElement = this.querySelector('[data-swiper-related-products-next]');
    const prevButtonElement = this.querySelector('[data-swiper-related-products-prev]');

    if (!swiperElement) {
      return;
    }

    new Swiper(swiperElement, {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 10,
      followFinger: true,
      touchRatio: 1,
      resistance: true,
      resistanceRatio: 0.85,
      speed: 600,
      effect: 'slide',
      pagination: {
        el: paginationElement,
        clickable: true,
      },
      navigation: {
        nextEl: nextButtonElement,
        prevEl: prevButtonElement,
      },
      breakpoints: {
        280: {
          slidesPerView: 2.3,
          slidesPerGroup: 1,
          spaceBetween: 13,
        },
        992: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 10,
        },
        1200: {
          slidesPerView: 5,
          slidesPerGroup: 5,
          spaceBetween: 10,
        },
      },
    });
  }

  updateHighestPrice() {
    const prices = this.querySelectorAll('[data-price-item-regular]');
    let highestPriceText = '';
    let currencySymbol = '';

    prices.forEach(price => {
      const priceText = Number(price.textContent.trim().replace(",", "").slice(1));
      let price_number = price.textContent.trim();
      currencySymbol = price_number[0];
      if (priceText > highestPriceText) {
        highestPriceText = priceText;
      }
    });

    const highestPriceElement = this.querySelector('[data-article-related-products-highest-price]');
    if (highestPriceElement) {
      highestPriceElement.textContent = currencySymbol + highestPriceText.toLocaleString();
    }
  }
}

customElements.define('related-products-slider', RelatedProductsSlider);
